// 公共
export const PurchaserRouterName = {
  /** 组合商品列表 */
  ProductCombinationList: '/purchaser/cookbook/product_combination/list',
  /** 组合商品详情 */
  ProductCombinationDetail: '/purchaser/cookbook/product_combination/detail',
  /** 组合商品编辑 */
  ProductCombinationEdit: '/purchaser/cookbook/product_combination/edit',
  /** 组合商品新增 */
  ProductCombinationAdd: '/purchaser/cookbook/product_combination/add',

  /** 缴费单 */
  PaymentReceipt: '/purchaser/cookbook/payment_receipt/list',
  /** 缴费单详情 */
  PaymentReceiptDetail: '/purchaser/cookbook/payment_receipt/detail',
  /** 缴费单新增 */
  PaymentReceiptCreate: '/purchaser/cookbook/payment_receipt/create',
  /** 缴费单编辑 */
  PaymentReceiptEdit: '/purchaser/cookbook/payment_receipt/edit',
  /** 缴费单报餐记录 */
  MealRecordDetail: '/purchaser/cookbook/meal_record/detail',

  /** 缴费记录 */
  PaymentRecords: '/purchaser/cookbook/payment_records/list',
  /** 缴费记录新建 */
  PaymentRecordsCreate: '/purchaser/cookbook/payment_records/create',

  /** 售后单 */
  AfterSales: '/purchaser/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/purchaser/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/purchaser/after_sales/detail',
  /**
   * 售后单打印
   */
  AfterSalesPrint: '/purchaser/after_sales/print',
  /**
   * 售后单编辑
   */
  AfterSalesEdit: '/purchaser/after_sales/edit',

  //  TODO:全局替换重复的
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/purchaser/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/purchaser/bill/reconciliation/detail',
  /* * 编辑对账单
   * @param string statementNo 采购单编号
   * @description 使用方式 ${ReconciliationEdit}/${statementNo}
   * */
  ReconciliationAddForPurchaser: '/purchaser/bill/reconciliation/purchase_edit',
  AfterSalseAddForPurchaser: '/purchaser/bill/reconciliation/after_sales_edit',

  /** 商品行情价 */
  MarketPriceList: '/purchaser/purchase_order/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/purchaser/purchase_order/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/purchaser/purchase_order/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/purchaser/purchase_order/market_price/create',
  /** 行情价汇聚 */
  MarketPriceGatherList: '/purchaser/purchase_order/market_price_gather/list',

  /** 折扣定价单详情 */
  DiscountPricesDetail: '/purchaser/purchase_order/discount_price/detail',

  /** 折扣定价单公示列表 */
  DiscountPricesPublic: '/purchaser/report/discount_price_public/list',
  /** 折扣定价单公示结果 */
  DiscountPricesResult: '/purchaser/report/discount_price_public/result',

  /** 合同详情 */
  PublicPurchaserContractDetail: '/purchaser/report/discount_price_public/contract_detail',

  /** 询价单列表 */
  InquiryList: '/purchaser/inquiry_quotation/inquiry/list',
  /** 询价单创建 */
  InquiryCreate: '/purchaser/inquiry_quotation/inquiry/create',
  /** 询价单详情 */
  InquiryDetail: '/purchaser/inquiry_quotation/inquiry/detail',
  /** 询价单比价定价 */
  InquiryComparePirce: '/purchaser/inquiry_quotation/inquiry/compare_price',
  /** 询价单编辑 */
  InquiryEdit: '/purchaser/inquiry_quotation/inquiry/edit',
  /** 询价单复制 */
  InquiryCopy: '/purchaser/inquiry_quotation/inquiry/copy',

  /** 采购合同列表 */
  PurchaserContractList: '/purchaser/purchase_contract/list',
  /** 编辑采购合同 */
  PurchaserContractEdit: '/purchaser/purchase_contract/edit',
  /** 采购合同 */
  PurchaserContractDetail: '/purchaser/purchase_contract/detail',
  PurchaserContractAddForQuation: '/purchaser/purchase_contract/quotation/add',

  /** 报价单列表 */
  QuotationList: '/purchaser/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  QuotationDetail: '/purchaser/inquiry_quotation/quotation/detail',
  /** 报价单详情-单号查询 */
  QuotationDetailByNo: '/purchaser/inquiry_quotation/quotation/detail_no',

  /** 执行台账记录 */
  ExecutionRecordList: '/purchaser/operate/execution_record/list',
  /** 执行台账记录详情 */
  ExecutionRecordDetail: '/purchaser/operate/execution_record/detail',

  /** 验收标准详情 */
  AcceptanceCriteriaDetail: '/purchaser/acceptance_criteria/detail',

  /** 采购评价 */
  PurchaseEvaluateList: '/purchaser/report/purchase_evaluate/list',
  /** 采购单 */
  PurchaseOrderList: '/purchaser/purchase_order/list',
  /** 整改记录 */
  RectificationRecordList: '/purchaser/operate/rectification_record/list',
  /** 售后明细 */
  AfterSaleDetailReportList: '/purchaser/after_sales_detail_report/list',
  /** 对账明细表 */
  StatementDetailReportList: '/purchaser/report/statement_detail_report/list',
  /** 回单记录 */
  ReturnReceiptRecordList: '/purchaser/return_receipt_record/list',
  /** 采购进度 */
  PurchaseProgressList: '/purchaser/purchase_progress/list',
  /** 查看答卷 */
  ExaminationExamAnswerDetail: '/purchaser/examination/exam_answer_detail',
  /** 答题 */
  ExaminationExamAnswer: '/purchaser/examination/exam_answer',
  /** 仓库管理 */
  WarehouseList: '/purchaser/inventory/warehouse/list',
};

/** 需方平台路由 */
export const purchaserRoutes = {
  /** 收据 */
  PurchaserReceipt: '/purchaser/platform/receipt/list',
  /** 废弃物处理列表 */
  PurchaserWasteDisposalList: '/purchaser/operate/waste_disposal/list',
  /** 新建废弃物处理 */
  PurchaserWasteDisposalCreate: '/purchaser/operate/waste_disposal/create',
  /** 编辑废弃物处理 */
  PurchaserWasteDisposalEdit: '/purchaser/operate/waste_disposal/edit',
  /** 周转筐借还列表 */
  PurchaserTurnoverBasketList: '/purchaser/logistics/turnover_basket/list',
  /** 周转筐借还行车监控列表 */
  PurchaserTurnoverBasketVehicleMonitorList: '/purchaser/logistics/vehicle_monitor/list',
  /** 周转筐借还行车监控详情 */
  PurchaserTurnoverBasketVehicleMonitorDetail: '/purchaser/logistics/vehicle_monitor/detail',
  /** 周转筐借还详情 */
  PurchaserTurnoverBasketDetail: '/purchaser/logistics/turnover_basket/detail',
  /** 每日价格 */
  DailyPriceList: '/purchaser/daily_price/list',
  /** 库存明细表 */
  StockDetailReportList: '/purchaser/report/stock_detail_report/list',
  /** 库存损耗表 */
  PurchaserInventoryLossReportList: '/purchaser/report/inventory_loss_report/list',
  /** 配送损耗表 */
  PurchaserDeliveryLossReportList: '/purchaser/report/delivery_loss_report/list',
  /** 采购明细表 */
  PurchaseDetailReportList: '/purchaser/report/purchase_detail_report/list',
  /** 档口 */
  PurchaseStallList: '/purchaser/setting/stall/list',
  /** 新建档口 */
  PurchaseStallCreate: '/purchaser/setting/stall/create',
  /** 编辑档口 */
  PurchaseStallEdit: '/purchaser/setting/stall/edit',
  /** 档口详情 */
  PurchaseStallDetail: '/purchaser/setting/stall/detail',
  /** 食堂 */
  PurchaseDiningList: '/purchaser/setting/dining/list',
  /** 新建食堂 */
  PurchaseDiningCreate: '/purchaser/setting/dining/create',
  /** 编辑食堂 */
  PurchaseDiningEdit: '/purchaser/setting/dining/edit',
  /** 食堂详情 */
  PurchaseDiningDetail: '/purchaser/setting/dining/detail',
  /** 食堂出入库规则 */
  PurchaseDiningInboundOutboundRules: '/purchaser/setting/dining/inbound_outbound_rules',
  /** 食堂库位分配规则 */
  PurchaseDiningPositionRules: '/purchaser/setting/dining/position_rules',
  /** 明厨亮灶 */
  PurchaseBrightKitchen: '/purchaser/operate/bright_kitchen',
  /** 明厨亮灶全屏 */
  PurchaseBrightKitchenFullScreen: '/purchaser/operate/bright_kitchen/full_screen',
  /** 数据大屏 */
  PurchaserScreen: '/purchaser/screen',
  /** 违规记录 */
  PurchaseViolationRecordList: '/purchaser/operate/violation_record/list',
  /** 项目公示列表 */
  PurchaseProjectManageList: '/purchaser/report/project_public/list',
  /** 项目公示结果 */
  PurchaseProjectManageResult: '/purchaser/report/project_public/result',
  /** 项目公示结果-编号查询 */
  PurchaseProjectManageResultByNo: '/purchaser/report/project_public/result_no',
  /** 报价单详情 */
  PurchaseProjectQuotationDetail: '/purchaser/report/project_public/quotation_detail',
  /** 就餐日历 */
  PurchaserDiningCalendarList: '/purchaser/cookbook/dining_calendar/list',
  /** 新建陪餐记录 */
  AccompanyCreatePurchaser: '/purchaser/operate/accompany_meal/create',
  /** 编辑陪餐记录 */
  AccompanyEditPurchaser: '/purchaser/operate/accompany_meal/edit',
  /** 陪餐记录 */
  AccompanyListPurchaser: '/purchaser/operate/accompany_meal/list',
  /** 消杀列表 */
  PurchaserDisinfectList: '/purchaser/operate/disinfect/list',
  /** 消杀详情 */
  PurchaserDisinfectDetail: '/purchaser/operate/disinfect/detail',
  /** 新建消杀记录 */
  PurchaserDisinfectCreate: '/purchaser/operate/disinfect/create',
  /** 编辑消杀记录 */
  PurchaserDisinfectEdit: '/purchaser/operate/disinfect/edit',
  /** 晨检列表 */
  PurchaserMorningCheckList: '/purchaser/operate/morning_check/list',
  /** 晨检记录详情 */
  PurchaserMorningCheckDetail: '/purchaser/operate/morning_check/detail',
  /** 新建晨检记录 */
  PurchaserMorningCheckCreate: '/purchaser/operate/morning_check/create',
  /** 编辑晨检记录 */
  PurchaserMorningCheckEdit: '/purchaser/operate/morning_check/edit',
  /** 新品提报 */
  NewSubmissionList: '/purchaser/purchase_order/new_submission/list',
  /** 报餐记录 */
  PurchaserMealRecordList: '/purchaser/cookbook/meal_record/list',
  /** 报餐记录详情 */
  PurchaserMealRecordDetail: '/purchaser/cookbook/meal_record/detail',
  /** 编辑报餐记录 */
  PurchaserMealRecordEdit: '/purchaser/cookbook/meal_record/edit',
  /** 新建报餐记录 */
  PurchaserMealRecordCreate: '/purchaser/cookbook/meal_record/create',
  /**
   * 缴费单详情
   * @description 使用方式 ${PurchaserPaymentReceiptDetail}/${paymentSlipId}
   * */
  PurchaserPaymentReceiptDetail: '/purchaser/cookbook/payment_receipt/detail',
  /** 报餐规则 */
  PurchaserMealRulesList: '/purchaser/cookbook/meal_rules/list',
  /** 投诉建议列表 */
  PurchaserSuggestionList: '/purchaser/operate/suggestion/list',
  /** 补货规则 */
  PurchaserReplenishList: '/purchaser/inventory/replenish_rules/list',
  /** 商品预警 */
  PurchaserProductWarningList: '/purchaser/inventory/product_warning/list',
  /** 库存回退 */
  PurchaserInventoryRollbackList: '/purchaser/inventory/inventory_rollback/list',
  /** 付款单列表 */
  PurchaserPaymentStatementList: '/purchaser/payment_statements/list',
  /** 开票记录列表 */
  PurchaserBillRecordList: '/purchaser/payment_statements/bill_record/list',
  /** 开票记录详情 */
  PurchaserBillRecordDetail: '/purchaser/payment_statements/bill_record/detail',
  /** 申领单列表 */
  PurchaserRequisitionList: '/purchaser/inventory/requisition/list',
  /** 申领单详情 */
  PurchaserRequisitionDetail: '/purchaser/inventory/requisition/detail',
  /** 申领单编辑 */
  PurchaserRequisitionEdit: '/purchaser/inventory/requisition/edit',
  /** 申领单创建 */
  PurchaserRequisitionCreate: '/purchaser/inventory/requisition/create',
  /** 申领单完成 */
  PurchaserRequisitionComplete: '/purchaser/inventory/requisition/complete',
  /** 申领单打印 */
  PurchaserRequisitionPrint: '/purchaser/inventory/requisition/print',
  /** 留样管理 */
  KeepSamplePurchaser: '/purchaser/operate/keep_sample/list',
  /** 新增留样管理 */
  KeepSamplePurchaserCreate: '/purchaser/operate/keep_sample/create',
  /** 留样管理详情 */
  KeepSamplePurchaserDetail: '/purchaser/operate/keep_sample/detail',
  /** 留样管理编辑 */
  KeepSamplePurchaserEdit: '/purchaser/operate/keep_sample/edit',
  /** 巡检任务 */
  PurchaserOperateInspectionList: '/purchaser/operate/inspection/list',
  /** 新建巡检任务 */
  PurchaserOperateInspectionCreate: '/purchaser/operate/inspection/create',
  /** 编辑巡检任务 */
  PurchaserOperateInspectionEdit: '/purchaser/operate/inspection/edit',
  /** 完成巡检任务 */
  PurchaserOperateInspectionDetail: '/purchaser/operate/inspection/detail',
  /** 巡检任务模版列表 */
  PurchaserOperateTaskTemplateList: '/purchaser/operate/task_template/list',
  /** 新建巡检任务模版 */
  PurchaserOperateTaskTemplateCreate: '/purchaser/operate/task_template/create',
  /** 编辑巡检任务模版 */
  PurchaserOperateTaskTemplateEdit: '/purchaser/operate/task_template/edit',
  /** 下达采购 */
  ApplySendPurchasePurchaser: '/purchaser/apply_purchase/send_purchase',
  /** 溯源管理 */
  PurchaseSuyuanManage: '/purchaser/purchase_order/suyuan',
  /** 账户管理 */
  TurnoverListTurnover: '/purchaser/payment_statements/account_turnover/list',
  /** 物料转换 */
  MaterialConversionPurchaser: '/purchaser/inventory/material_conversion/list',
  /** 新增物料转换 */
  MaterialConversionAddPurchaser: '/purchaser/inventory/material_conversion/add',
  /** 编辑物料转换 */
  MaterialConversionEditPurchaser: '/purchaser/inventory/material_conversion/edit',
  /** 物料转换详情 */
  MaterialConversionDetailPurchaser: '/purchaser/inventory/material_conversion/detail',
  /** 批量物料转换 */
  MaterialConversionBatchPurchaser: '/purchaser/inventory/material_conversion/batch_add',
  /** 盘点单管理 */
  InventorySheetPurchaser: '/purchaser/inventory/inventory_sheet/list',
  /** 新增盘点单 */
  InventorySheetAddPurchaser: '/purchaser/inventory/inventory_sheet/add',
  /** 编辑盘点单 */
  InventorySheetEditPurchaser: '/purchaser/inventory/inventory_sheet/edit',
  /** 盘点单详情 */
  InventorySheetDetailPurchaser: '/purchaser/inventory/inventory_sheet/detail',
  /** 盘点 */
  InventoryPurchaser: '/purchaser/inventory/inventory_sheet/inventory',
  /** 过账 */
  PostedPurchaser: '/purchaser/inventory/inventory_sheet/posted',
  /** 保质期记录 */
  PurchaserShelfLifeRecordList: '/purchaser/inventory/shelf_life_record/list',
  /** 新建保质期记录 */
  PurchaserShelfLifeRecordCreate: '/purchaser/inventory/shelf_life_record/create',
  /** 保质期跟踪 */
  PurchaserShelfLifeTrackList: '/purchaser/inventory/shelf_life_track/list',
  /** 班级管理 */
  ClassPurchaser: '/purchaser/cookbook/class_manage/list',
  /** 就餐人员 */
  DinePersonnelPurchaser: '/purchaser/cookbook/dine_personnel/list',

  /** 入库单管理 */
  InboundOrderPurchaser: '/purchaser/inventory/inbound_order/list',
  /** 新增入库单 */
  InboundOrderAddPurchaser: '/purchaser/inventory/inbound_order/add',
  /** 编辑入库单 */
  InboundOrderEditPurchaser: '/purchaser/inventory/inbound_order/edit',
  /** 入库单详情 */
  InboundOrderDetailPurchaser: '/purchaser/inventory/inbound_order/detail',
  /** 入库单打印 */
  InboundOrderPrint: '/purchaser/inventory/inbound_order/print',
  /** 出库单管理 */
  OutboundOrderPurchaser: '/purchaser/inventory/outbound_order/list',
  /** 新增出库单 */
  OutboundOrderAddPurchaser: '/purchaser/inventory/outbound_order/add',
  /** 编辑出库单 */
  OutboundOrderEditPurchaser: '/purchaser/inventory/outbound_order/edit',
  /** 出库单详情 */
  OutboundOrderDetailPurchaser: '/purchaser/inventory/outbound_order/detail',
  /** 出库单打印 */
  OutboundOrderPrint: '/purchaser/inventory/outbound_order/print',
  /** 库存台账 */
  LedgerPurchaser: '/purchaser/inventory/inventory_ledger/list',
  /** 实时库存 */
  RealInventoryPurchaser: '/purchaser/inventory/real_inventory',
  /** 员工管理 */
  PurchaserEmployeeList: '/purchaser/setting/employee/list',
  /** 账户流水 */
  TurnoverListPurchaser: '/purchaser/payment_statements/turnover/list',
  /** 下达采购 */
  PurchaseSendPurchase: '/purchaser/cookbook/cookbook_manage/send_purchase',
  /** 下达申购 */
  PurchaseSendApplyPurchase: '/purchaser/cookbook/cookbook_manage/send_apply_purchase',
  /** 菜谱管理 */
  PurchaseCookbookList: '/purchaser/cookbook/cookbook_manage/list',
  /** 菜谱详情 */
  PurchaseCookbookDetail: '/purchaser/cookbook/cookbook_manage/detail',
  /** 新建自用菜谱 */
  PurchaseCookbookCreate: '/purchaser/cookbook/cookbook_manage/create',
  /** 复制自用菜谱 */
  PurchaseCookbookCopy: '/purchaser/cookbook/cookbook_manage/copy',
  /** 编辑自用菜谱 */
  PurchaseCookbookEdit: '/purchaser/cookbook/cookbook_manage/edit',
  /** 申购单 */
  ApplyPurchaseListForPurchaser: '/purchaser/apply_purchase/list',
  /** 申购单详情 */
  ApplyPurchaseDetailForPurchaser: '/purchaser/apply_purchase/detail',
  /** 编辑申购单 */
  ApplyPurchaseEditForPurchaser: '/purchaser/apply_purchase/edit',
  /** 复制申购单 */
  ApplyPurchaseCopyForPurchaser: '/purchaser/apply_purchase/copy',
  /** 新增申购单 */
  ApplyPurchaseAddForPurchaser: '/purchaser/apply_purchase/add',
  /** 申购商品明细 */
  ApplyGoodsDetailForPurchaser: '/purchaser/apply_purchase/apply_goods_detail/list',
  ReconciliationList: '/purchaser/bill/reconciliation/list',
  ReconciliationListByPayment: '/purchaser/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  ReconciliationDetail: '/purchaser/bill/reconciliation/detail',
  /** 创建对账单 */
  ReconciliationCreate: '/purchaser/bill/reconciliation/create',
  /* * 从对账单创建对账单
   * @param string statementNo 采购单编号
   * @description 使用方式 ${ReconciliationEdit}/${statementNo}
   * */
  ReconciliationAddForPurchaser: '/purchaser/bill/reconciliation/purchase_edit',
  /**
   * 采购单列表
   */
  PurchaserOrderList: '/purchaser/purchase_order/list',
  /** 需方预警-质检报告缺失（采购单） */
  PurchaserWarningQualityReportMissingList: '/purchaser/warning/quality_report_missing',
  /** 需方预警-差评采购单 */
  PurchaserWarningBadReviewsPurchaseList: '/purchaser/warning/bad_reviews_purchase',
  /** 需方预警-逾期送达 */
  PurchaserWarningOverdueDeliveryPurchaseList: '/purchaser/warning/overdue_delivery_purchase',
  /** 需方预警-少送错送 */
  PurchaserWarningLessDeliveryPurchaseList: '/purchaser/warning/less_delivery_purchase',
  /** 需方预警-包装破损 */
  PurchaserWarningDamagedPackagePurchaseList: '/purchaser/warning/damaged_package_purchase',
  /** 需方预警-温湿度不达标 */
  PurchaserWarningTemperatureHumidityPurchaseList: '/purchaser/warning/temperature_humidity_purchase',
  /** 需方预警-健康证过期员工 */
  PurchaserWarningHealthCertExpiredList: '/purchaser/warning/health_cert_expired',
  /**
   * 采购单创建
   */
  PurchaserOrderCreate: '/purchaser/purchase_order/create',
  /**
   * 采购单补录
   */
  PurchaserOrderRepair: '/purchaser/purchase_order/repair',
  /**
   * 采购单批量创建
   */
  PurchaseOrderBatchCreate: '/purchaser/purchase_order/batch_create',
  /**
   * 采购单编辑
   */
  PurchaserOrderEdit: '/purchaser/purchase_order/edit',
  /**
   * 采购单复制
   */
  PurchaserOrderCopy: '/purchaser/purchase_order/copy',
  /**
   * 采购单详情
   */
  PurchaserOrderDetail: '/purchaser/purchase_order/detail',
  /** 申领单打印 */
  PurchaserOrderPrint: '/purchaser/purchase_order/print',
  /* * 编辑对账单
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationEdit}/${statementNo}
   * */
  ReconciliationEdit: '/purchaser/bill/reconciliation/edit',
  /** 采购汇总表 */
  PurchaserPurchaseReportList: '/purchaser/report/purchase_report/list',
  /** 财务汇总表 */
  PurchaserFinancialReportList: '/purchaser/report/financial_report/list',
  /** 询价公示 */
  PurchaserInquiryPublic: '/purchaser/report/inquiry_public/list',
  /** 公示结果 */
  PurchaserPublicResult: '/purchaser/report/inquiry_public/result',
  /** 询价公示-采购合同详情 */
  PurchaserInquiryPublicContractDetail: '/purchaser/report/inquiry_public/contract_detail',
  /** 计划到货明细 */
  DeliveryList: '/purchaser/purchase_order/delivery_list',
  /** 应付汇总 */
  PayableSummary: '/purchaser/bill/payable/list',
  /** 角色创建 */
  PurchaserRoleCreate: '/purchaser/role/create',
  /** 角色列表 */
  PurchaserRoleList: '/purchaser/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  PurchaserRoleEdit: '/purchaser/role/editor',
  /** 收支管理 */
  IncomeExpenseList: '/purchaser/bill/income_expense/list',
  /** 工单 */
  PurchaserWorkOrder: '/purchaser/platform/work_order/list',
  /** 四单匹配 */
  PurchaserFourMatchList: '/purchaser/four_match/list',
  /** 财务合规审查 */
  PurchaserFinancialComplianceList: '/purchaser/financial_compliance/list',
  /** 预算编制单 */
  PurchaserBudgetPreparationList: '/purchaser/budget_preparation/list',
  /** 新建预算编制单 */
  PurchaserBudgetPreparationCreate: '/purchaser/budget_preparation/create',
  /** 编辑预算编制单 */
  PurchaserBudgetPreparationEdit: '/purchaser/budget_preparation/edit',
  /** 预算跟踪 */
  PurchaserBudgetPreparationTracking: '/purchaser/budget_preparation/tracking',
  /** 新建仓库 */
  PurchaserWarehouseCreate: '/purchaser/inventory/warehouse/create',
  /**
   * 编辑仓库
   * `/${id}` 为编辑
   * */
  PurchaserWarehouseEdit: '/purchaser/inventory/warehouse/edit',
  /**
   * 库位分配规则
   * ?productCategoryId=${productCategoryId}&productCategoryName=${productCategoryName}
   * */
  PurchaserPositionRules: '/purchaser/inventory/position_rules/list',
  /** 资金记录列表 */
  PurchaserFundRecordList: '/purchaser/fund_record/list',
  /** 凭证类别列表 */
  PurchaserVoucherCategoryList: '/purchaser/voucher_category/list',
  /** 分录规则列表 */
  PurchaserEntryRuleList: '/purchaser/entry_rule/list',
  /** 部门列表 */
  PurchaserDepartmentList: '/purchaser/department/list',
  /** 辅助核算列表 */
  PurchaserAuxiliaryAccountingList: '/purchaser/auxiliary_accounting/list',
  /** 借贷科目列表 */
  PurchaserDebitCreditSubjectList: '/purchaser/debit_credit_subject/list',
  /** 账套列表 */
  PurchaserAccountBookList: '/purchaser/account_book/list',
  /** 记账凭证模版列表 */
  PurchaserVoucherTemplateList: '/purchaser/voucher_template/list',
  /** 记账凭证列表 */
  PurchaserVoucherList: '/purchaser/voucher/list',
  /** 凭证生成列表 */
  PurchaserVoucherGenerateList: '/purchaser/voucher_generate/list',
  /** 新建记账凭证 */
  PurchaserVoucherCreate: '/purchaser/voucher/create',
  /** 编辑记账凭证 */
  PurchaserVoucherEdit: '/purchaser/voucher/edit',
  /** 记账凭证详情 */
  PurchaserVoucherDetail: '/purchaser/voucher/detail',
  /** 经营计算器 */
  PurchaserBusinessCalculatorList: '/purchaser/business_calculator/list',
};
